<template>
  <BaseCard>
    <BaseCardBody clear-padding class="overflow-hidden relative">
      <img :src="post.full_picture" class="aspect-[1/1] object-cover" />
      <a
        :href="post.permalink_url"
        target="_blank"
        class="absolute inset-0 w-full h-full flex items-center justify-center group hover:bg-black hover:bg-opacity-50 transition-all"
      >
        <span
          class="hidden group-hover:inline-flex text-white border border-white px-6 py-3 hover:bg-white hover:text-black transition-all rounded"
          >VIEW {{ isVideoPost ? 'VIDEO' : 'POST' }}</span
        >
      </a>
    </BaseCardBody>
    <BaseCardBody class="space-y-5">
      <div class="text-gray-600 text-xs">{{ createdAt }}</div>
      <p v-if="hasMessage" class="break-words text-sm">
        {{ message }}
      </p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import moment from 'moment';
import { truncate } from 'lodash-es';

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasMessage() {
      return typeof this.post.message === 'string';
    },
    message() {
      return this.hasMessage ? truncate(this.post.message, { length: 125 }) : '';
    },
    isVideoPost() {
      return this.post.permalink_url.includes('/videos/');
    },
    createdAt() {
      return moment.utc(this.post.created_time).local().format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>
